import request from '@/utils/util.request';
/**
 * @desc (wxbind) 微信绑定数据加载
 */
export const wxbind_load_data = (data) => {
	return request({
		url: '/wxbind/loaddata',
		data,
	});
};
/**
 * @decs (wxbind) 修改配置后保存
 * @param {string} type : bind | onlyme | wxautoin
 * @param {int} value : 0 | 1
 */
export const wxbind_edit = (data) => {
	return request({
		url: '/wxbind/edit',
		data,
	});
};
